import React, { useEffect, useState, useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import dayjs from "dayjs";
import { getData, postData } from "../Commonfunction/CommonFunction";

const validationSchema = Yup.object({
  financial_start: Yup.date().required("Financial start date is required"),
  financial_end: Yup.date().required("Financial end date is required"),
});

const FinancialYearForm = ({
  onClose,
  id,
  fetchData,
  setCutoffModal,
  fetchDataUserAccess,
}) => {
  const [singleData, setSingleData] = useState();
  const [isEndDateAutoSet, setIsEndDateAutoSet] = useState(false);
  const formikRef = useRef();
  const location = useLocation();

  const singleFinancialYearData = async () => {
    try {
      const result = await getData(`/api/get-financial-year/${id}`);
      if (result.success) {
        setSingleData(result.data);
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  const handleSubmit = async (finalValue) => {
    try {
      // const request_url = "/api/create-financial-year";

      const request_url = id
        ? `/api/update-financial-year/${id}`
        : "/api/create-financial-year";
      const postDataResult = await postData(request_url, finalValue);
      toast.success(postDataResult?.message);
      location.pathname == "/" && fetchDataUserAccess();

      // location.pathname == "/dashboard" && setCutoffModal(true);
      onClose();

      fetchData();
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  useEffect(() => {
    if (id) {
      singleFinancialYearData();
    }
  }, [id]);

  // Handle auto-setting end date
  useEffect(() => {
    const formik = formikRef.current;
    const startDate = formik?.values?.financial_start;
    const endDate = formik?.values?.financial_end;

    if (startDate && (!endDate || isEndDateAutoSet)) {
      const newEndDate = dayjs(startDate).add(1, "year").subtract(1, "day");
      formik?.setFieldValue("financial_end", newEndDate);
      setIsEndDateAutoSet(true);
    }
  }, [formikRef.current?.values?.financial_start]);

  const initialValues = {
    financial_start: singleData?.financial_start
      ? dayjs(singleData.financial_start)
      : null,
    financial_end: singleData?.financial_end
      ? dayjs(singleData.financial_end)
      : null,
  };

  return (
    <Formik
      innerRef={formikRef}
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        const finalValue = {
          financial_start: values.financial_start.format("MM-DD-YYYY"),
          financial_end: values.financial_end.format("MM-DD-YYYY"),
        };
        handleSubmit(finalValue);
      }}
    >
      {({ errors, touched, setFieldValue, values }) => (
        <Form>
          <div className="form-body">
            <div className="grid-row">
              <div className="grid-col-6">
                <div className="form-group">
                  <label htmlFor="financial_start">
                    {" "}
                    Financial Start Date <span className="text-red">*</span>
                  </label>
                  <Field
                    id="financial_start"
                    name="financial_start"
                    type="date"
                    onChange={(e) => {
                      const date = dayjs(e.target.value);
                      setFieldValue("financial_start", date);
                      setIsEndDateAutoSet(true);
                    }}
                    value={
                      values.financial_start
                        ? dayjs(values.financial_start).format("YYYY-MM-DD")
                        : ""
                    }
                    className={
                      errors.financial_start && touched.financial_start
                        ? "input-error"
                        : ""
                    }
                  />
                  <ErrorMessage
                    name="financial_start"
                    component="div"
                    className="error-message"
                  />
                </div>
              </div>

              <div className="grid-col-6">
                <div className="form-group">
                  <label htmlFor="financial_end">
                    {" "}
                    Financial End Date <span className="text-red">*</span>
                  </label>
                  <Field
                    id="financial_end"
                    name="financial_end"
                    type="date"
                    readOnly
                    onChange={(e) => {
                      const date = dayjs(e.target.value);
                      setFieldValue("financial_end", date);
                      setIsEndDateAutoSet(false);
                    }}
                    value={
                      values.financial_end
                        ? dayjs(values.financial_end).format("YYYY-MM-DD")
                        : ""
                    }
                    className={
                      errors.financial_end && touched.financial_end
                        ? "input-error"
                        : ""
                    }
                  />
                  <ErrorMessage
                    name="financial_end"
                    component="div"
                    className="error-message"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="form-footer">
            <button type="button" className="btn btn-cancel" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-submit">
              Submit
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default FinancialYearForm;
